<template>
  <div>

    <v-form v-model="valid" ref="form" @keypress.enter="login">
      <v-card class="ma-auto mt-16" width="300" rounded variant="elevated">
        <v-card-title>
          <v-icon>mdi-key</v-icon>
          <span class="mr-2">تسجيل الدخول</span>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <div ref="icon" class="text-center " style="width: 100%">
            <v-icon color="#4f4d4d" class="ma-auto" size="100">mdi-lock</v-icon>
          </div>
          <div>
            <v-text-field ref="username" :rules="req" class="text-center" variant="underlined" prepend-inner-icon="mdi-account" label="اسم المستخدم" v-model="user.username"></v-text-field>
            <v-text-field :rules="req" variant="underlined" type="password" prepend-inner-icon="mdi-eye-off" label="كلمة المرور" v-model="user.password"></v-text-field>

          </div>
        </v-card-text>
        <v-divider v-if="unauth" />
        <div style="height: 50px;overflow-y: hidden">
          <div style="transition: .2s linear;margin-top: -50px" ref="msg" class="pa-2 text-center" >{{msg}}</div>
        </div>
        <v-divider/>
        <v-card-actions>
          <v-btn variant="elevated" color="primary" :loading="loading" @click="login" tabindex="2">
            <v-icon>mdi-key</v-icon>
            <span class="mr-2">دخول</span>
          </v-btn>

        </v-card-actions>
      </v-card>

    </v-form>

  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      user: {
        username: '',
        password: '',
      },
      show: false,
      valid: true,
      req: [v => !!v || 'لايمكن تركه فارغاً'],
      unauth: false,
      msg: '',
    };
  },
  methods: {
    async login() {
      this.unauth = false;
      if (this.$refs.form.validate()) {
        this.$refs.icon.classList.remove("animation");
        this.$refs.msg.style.marginTop = "-50px";

        this.loading = true;
        this.$axios.post('api/login', this.user).then(res => {
          const token = res.data.access_token
          const user = res.data.user

          // Save to localStorage
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))

          // Set token in Axios headers
          this.$axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

          // Optional: Redirect to dashboard

          this.$router.push('/vendors')
        }).catch(err => {
          if (err.response.status == 401) {
            this.$refs.msg.style.marginTop = "0px";
            this.$refs.icon.classList.add("animation");
            this.unauth = true;
            this.msg = err.response.data.message;
          }

        }).finally(fin => {
          this.loading = false;
        })
      }
    }
  },
  mounted() {
    this.$refs.username.focus();
  }
};
</script>

<style scoped>
::v-deep(.v-text-field input) {
  text-align: center !important;
  direction: ltr;
}

@keyframes anime {
  0% {
    transform: translateX(0px);
  }
  20% {
    transform: translateX(10px);
  }
  40% {
    transform: translateX(-10px);
  }
  60% {
    transform: translateX(10px);
  }
  80% {
    transform: translateX(-10px);
  }

  100% {
    transform: translateX(0px);
  }
}

.animation {
  animation: anime .3s linear;
}
</style>
